import ApplicationStore from '../stores/ApplicationStore';

export function login(returnTo) {
  return (context) => {
    const appStore = context.getStore(ApplicationStore);

    let url = `${appStore.getDomainUrlDocs()}/auth/login`;
    if (returnTo) {
      url += `?returnTo=${returnTo}`;
    }

    context.trackEvent('click:auth0-docs:login');
    window.location = url;
  };
}

export function signup(context) {
  const appStore = context.getStore(ApplicationStore);
  const url = appStore.getDomainUrlSignup();
  context.trackEvent('click:auth0-docs:signup');
  window.location = url;
}
